import React from "react";
import { Container, Tab, Tabs } from "@material-ui/core";

import EditUserDialog from "components/User/EditUser/EditUserDialog";
import UserTable from "./UserTable/UserTable";
import InviteUserDialog from "./CreateUser/InviteUserDialog";
import UsersOverview from "./UsersOverview";
import FilterBar from "./FilterBar";
import ConfirmationDialog from "./UserTable/ConfirmationDialog";
import ApprovalsTable from "./ApprovalsTable/ApprovalsTable";
import { useSelector } from "react-redux";
import { TABS } from "./constants";
import userActions from "./actions";

const UsersContainer = () => {
  const { selectedTab } = useSelector((state) => state.user);
  const { setTab } = userActions();
  return (
    <Container>
      <UsersOverview />
      <Tabs
        value={selectedTab}
        indicatorColor="primary"
        textColor="primary"
        onChange={(event, newValue) => {
          setTab(newValue);
        }}
      >
        <Tab label="Members" value={TABS.MEMBER_TAB} />
        <Tab label="Pending Approvals" value={TABS.APPROVAL_TAB} />
      </Tabs>
      <FilterBar />
      {selectedTab === TABS.MEMBER_TAB && <UserTable />}
      {selectedTab === TABS.APPROVAL_TAB && <ApprovalsTable />}
      <InviteUserDialog />
      <EditUserDialog />
      <ConfirmationDialog />
    </Container>
  );
};

export default UsersContainer;
